// ConfigureSummaryModal.jsx

import React from "react";
import { Modal } from "react-bootstrap";
import { Switch } from "antd";
import styled from "styled-components";

const StyledModal = styled(Modal)`
  .modal-dialog {
    max-width: 420px !important;
    width: 420px !important;
  }
`;

const ConfigSubtitle = styled.p`
  font-size: 13px;
  color: #7b8695;
  margin: 0 0 16px 0;
`;

const ConfigItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #f0f4f8;

  &:last-child {
    border-bottom: none;
  }
`;

const ConfigItemLabel = styled.span`
  font-size: 14px;
  color: #2e2e2e;
  font-weight: 500;
`;

const SUMMARY_CATEGORIES = [
  "Problems",
  "Allergies",
  "Medications",
  "Recent Appointments",
  "Health Screening",
  "Vitals",
  "Immunizations",
  "Procedure & Surgeries",
  "Lab Results",
  "Social History",
  "Family History",
  "Alerts & Clinical Warning",
  "Treatment Plan",
  "Care Plan",
  "Care Team",
];

const DEFAULT_TOGGLES = SUMMARY_CATEGORIES.reduce((acc, cat) => {
  acc[cat] = true;
  return acc;
}, {});

const ConfigureSummaryModal = ({
  show,
  onHide,
  configToggles,
  setConfigToggles,
  onSave,
  loading,
}) => {
  return (
    <StyledModal
      className="client-popup-for-billing-profiles popup_centre"
      dialogClassName="configure-summary-modal"
      centered
      show={show}
      onHide={onHide}
    >
      <Modal.Header closeButton>
        <div className="ed-doc-mod-title">Summary Configuration</div>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: "450px", overflowY: "scroll" }}>
        <ConfigSubtitle>
          Select which patient summary you want to look at
        </ConfigSubtitle>
        {SUMMARY_CATEGORIES.map((cat) => (
          <ConfigItem key={cat}>
            <ConfigItemLabel>{cat}</ConfigItemLabel>
            <Switch
              checked={configToggles[cat]}
              onChange={(val) =>
                setConfigToggles((prev) => ({ ...prev, [cat]: val }))
              }
            />
          </ConfigItem>
        ))}
      </Modal.Body>
      <Modal.Footer>
        <button
          className="close_active add_edit_con_form_cancel_btn btn btn-light"
          onClick={onHide}
        >
          Cancel
        </button>
        <button
          className="save_active add_edit_con_form_upload_btn btn btn-primary"
          onClick={onSave}
          disabled={loading}
        >
          {loading ? "Saving..." : "Save"}
        </button>
      </Modal.Footer>
    </StyledModal>
  );
};

export { SUMMARY_CATEGORIES, DEFAULT_TOGGLES };
export default React.memo(ConfigureSummaryModal);
